import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
import { ApplicationForm } from '../components/JoinTeam/ApplicationForm';
import { Briefcase, PenTool, Monitor } from 'lucide-react';
export const JoinTeam = () => {
  const [showForm, setShowForm] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const roles = [{
    title: 'Community & Programs Lead',
    description: "You'll help manage our members, plan events, and keep our community active and thriving.",
    icon: <Briefcase size={24} className="text-gray-700" data-id="element-3509" data-mp="1lfxomow9jteo" />
  }, {
    title: 'Content & Communications Lead',
    description: "You'll create and share stories, social content, and updates that reflect who we are and what we do.",
    icon: <PenTool size={24} className="text-gray-700" data-id="element-3510" data-mp="1cegbnfe5k7u7" />
  }, {
    title: 'Tech & Systems Support',
    description: "You'll handle our digital tools, website updates, and help build smooth online experiences for our members.",
    icon: <Monitor size={24} className="text-gray-700" data-id="element-3511" data-mp="hp7m7xs2mdr0" />
  }];
  const handleFormSubmit = () => {
    setFormSubmitted(true);
  };
  // If the form has been submitted, show only the thank you message
  if (formSubmitted) {
    return <div className="pt-20 bg-white min-h-screen flex items-center justify-center" data-id="element-3512" data-mp="qhrhqpd2g27m">
        <div className="container mx-auto px-4 py-16" data-id="element-3513" data-mp="mfeblzueq2ab">
          <div className="max-w-3xl mx-auto" data-id="element-3514" data-mp="mgpnyo1x4id1">
            <div className="bg-white p-8 rounded-lg border-2 border-gray-200 text-center" data-id="element-3515" data-mp="3uv7swgwkbhsf">
              <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-3516" data-mp="3pwwl0bptvhcu">
                Thank you for applying to join The Networking Salon!
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-3517" data-mp="7sbfnxlqg1p3">
                Our team will review your submission and reach out to
                shortlisted applicants for the next steps.
              </p>
              <p className="text-gray-600" data-id="element-3518" data-mp="1j4c8bnlpwaa4">
                Keep an eye on your email and WhatsApp for updates.
              </p>
            </div>
          </div>
        </div>
      </div>;
  }
  // If apply button has been clicked, show only the form
  if (showForm) {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3519" data-mp="grpsufn0i9q2">
        <div className="container mx-auto px-4 py-16" data-id="element-3520" data-mp="kucnspezcarh">
          <div className="max-w-3xl mx-auto" data-id="element-3521" data-mp="kvnnoe5b0ydb">
            <ApplicationForm onFormSubmit={handleFormSubmit} data-id="element-3522" data-mp="ptgt34ys9ocj" />
          </div>
        </div>
      </div>;
  }
  // Default view - show the roles and apply button
  return <div className="pt-20 bg-white" data-id="element-3523" data-mp="3pa5bufpdnaih">
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-3524" data-mp="3ta5uydnf89vv">
        <div className="container mx-auto px-4" data-id="element-3525" data-mp="3t8345reg2cq3">
          <h1 className="text-4xl font-bold text-center text-gray-800 mb-6" data-id="element-3526" data-mp="23mjcw9rgfwi">
            JOIN THE NETWORKING SALON TEAM
            <span className="block text-2xl font-medium mt-2 text-gray-600" data-id="element-3527" data-mp="6vczxjzajzwd">
              (CONTRACT ROLES)
            </span>
          </h1>
          <p className="text-center text-lg text-gray-600 max-w-3xl mx-auto mb-8" data-id="element-3528" data-mp="35iqvqtqxy8ou">
            We're building a new kind of community — one where ideas meet
            people, and connections turn into real opportunities.
          </p>
          <p className="text-center text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-3529" data-mp="2y0sq50bvrhqw">
            The Networking Salon is expanding, and we're inviting passionate,
            creative, and reliable people to join our growing team on a contract
            basis.
          </p>
        </div>
      </section>
      <section className="py-16 border-b border-gray-200" data-id="element-3530" data-mp="2k1ko7zoc1vj0">
        <div className="container mx-auto px-4" data-id="element-3531" data-mp="2k3477y1dikoh">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3532" data-mp="2f9jfgnqdimxq">
            Open Roles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-3533" data-mp="2ac14yswpjznm">
            {roles.map((role, index) => <div key={index} className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3534" data-mp="25e7yrzven5nc" data-mpi={index}>
                <div className="flex items-center mb-4" data-id="element-3535" data-mp="21aa0frdwlyvc">
                  <div className="w-10 h-10 border-2 border-gray-300 rounded-full flex items-center justify-center mr-3" data-id="element-3536" data-mp="1wb6u83m6tmls">
                    {role.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-3537" data-mp="ay50ohykh60">
                    {role.title}
                  </h3>
                </div>
                <p className="text-gray-600 mb-0" data-id="element-3538" data-mp="3mn3oqdg60m5g">{role.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-3539" data-mp="3rleuabzfgahv">
        <div className="container mx-auto px-4" data-id="element-3540" data-mp="3cp7dlln89r7c">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8" data-id="element-3541" data-mp="3hp243o33cerv">
            About the Contract
          </h2>
          <div className="max-w-3xl mx-auto border-2 border-dashed border-gray-400 rounded-lg p-8" data-id="element-3542" data-mp="33pu08hvzgihc">
            <ul className="space-y-4 text-gray-600" data-id="element-3543" data-mp="38nvnzg4ct5z5">
              <li className="flex items-start" data-id="element-3544" data-mp="38qhs15s1d3cm">
                <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3" data-id="element-3545" data-mp="11xnzvo0ib7ig"></div>
                <span data-id="element-3546" data-mp="16wqueeiv1vc6">Part-time, project-based (3–6 months, renewable)</span>
              </li>
              <li className="flex items-start" data-id="element-3547" data-mp="1h0pgchx5hab8">
                <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3" data-id="element-3548" data-mp="1h1h0mwlarlm7"></div>
                <span data-id="element-3549" data-mp="1c2xcqqn57zr7">Work remotely or hybrid</span>
              </li>
              <li className="flex items-start" data-id="element-3550" data-mp="1pt0w99un1fcy">
                <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3" data-id="element-3551" data-mp="1puu1qltiltjd"></div>
                <span data-id="element-3552" data-mp="1l1hof7uad95x">
                  Payment: Commission or percentage-based on results (details
                  shared during onboarding)
                </span>
              </li>
            </ul>
          </div>
          <p className="text-center text-lg text-gray-600 max-w-3xl mx-auto mt-8" data-id="element-3553" data-mp="1uru70uijis9f">
            If you love building communities, telling stories, or creating
            systems that connect people — this is your chance to grow with us.
          </p>
          <div className="text-center mt-10" data-id="element-3554" data-mp="edufa6tum8x9">
            <Button onClick={() => setShowForm(true)} className="px-8 py-3 text-lg" data-id="element-3555" data-mp="eem5t38l9ggo">
              👉 Apply
            </Button>
          </div>
        </div>
      </section>
    </div>;
};